export default __webpack_public_path__ + "static/gridBg-d92848c374ef5bdd3b729daf4958ea8c.svg";